import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { useHidden } from "contexts/hidden";
import { useHighlighted } from "contexts/highlighted";
import { selectCoordinates } from "features/coordinates";
import { selectMeasure } from "features/measure";
import { selectOutlineLasers } from "features/outlineLaser";
import { selectPointLines } from "features/pointLine";
import { selectClippingPlanes, selectDefaultVisibility, selectMainObject, selectSubtrees } from "features/render";
import { explorerActions } from "slices/explorer";

/**
 * Resets the applied viewpoint when the user starts interacting with the viewer.
 */
export function useResetAppliedViewpoint() {
    const dispatch = useAppDispatch();

    // Here we select everything where changing it is considered resetting the viewpoint
    const highlighted = useHighlighted();
    const hidden = useHidden();
    const defaultVisibility = useAppSelector(selectDefaultVisibility);
    const subtrees = useAppSelector(selectSubtrees);
    const outlineLasers = useAppSelector(selectOutlineLasers);
    const coordinates = useAppSelector(selectCoordinates);
    const clippingPlanes = useAppSelector(selectClippingPlanes);
    const measure = useAppSelector(selectMeasure);
    const pointLines = useAppSelector(selectPointLines);
    const mainObject = useAppSelector(selectMainObject);

    useEffect(() => {
        dispatch(explorerActions.setAppliedViewpointToViewerInteraction());
    }, [
        dispatch,
        highlighted.idArr,
        hidden.idArr,
        defaultVisibility,
        subtrees,
        outlineLasers,
        coordinates,
        clippingPlanes.planes,
        measure.selectedEntities,
        pointLines,
        mainObject,
    ]);
}
